import React, { useEffect, useContext } from 'react';
import HomeNav from '../home/components/HomeNav';

import CountdownSection from './components/CountdownSection';
import FarmsStakingSection from './components/FarmsStakingSection';
import TotalValueLockedSection from './components/TotalValueLockedSection';
import NewsSection from './components/NewsSection';
import EarnUpToSection from './components/EarnUpToSection';
import MoneyRecipeSection from './components/MoneyRecipeSection';

import { FarmsContext } from '../../context/farms';
import { fetchFarms } from '../../blockchain/farms';
import { PoolsContext } from '../../context/pools';
import { fetchPools } from '../../blockchain/pools';
import { VaultsContext } from '../../context/vaults';
import { fetchVaults } from '../../blockchain/vaults';

import './DashboardPage.css';

function DashboardPage() {
  const { farmState, setFarmState } = useContext(FarmsContext);
  const { poolState, setPoolState } = useContext(PoolsContext);
  const { vaultState, setVaultState } = useContext(VaultsContext);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    const syncData = async () => {
      setFarmState(prevState => ({ ...prevState, loading: true }));
      const farmsResult = await fetchFarms();
      setFarmState(prevState => ({ ...prevState, ...farmsResult, loading: false }));

      setPoolState(prevState => ({ ...prevState, loading: true }));
      const poolsResult = await fetchPools();
      setPoolState(prevState => ({ ...prevState, ...poolsResult, loading: false }));

      setVaultState(prevState => ({ ...prevState, loading: true }));
      const vaultsResult = await fetchVaults();
      setVaultState(prevState => ({ ...prevState, ...vaultsResult, loading: false }));
    }

    const intervalId = setInterval(syncData, 10000);

    syncData();

    return () => clearInterval(intervalId);
  }, [setFarmState, setPoolState, setVaultState]);

  return (
    <>
      <HomeNav />
      <header className="hero parallax" style={{ backgroundImage: 'url("/images/parallax/bg-0.png")' }}>
        <div className="hero-body">
          <div className="container">
            <div className="hero-box has-text-centered">
              <p className="title">Banksy Finance</p>
              <p className="subtitle">The New Generation <span className="has-text-primary">Multi-Network</span> Yield Farming enhanced by <span className="has-text-primary">NFTs</span>.</p>
            </div>
          </div>
        </div>
      </header>
      <main role="main" className="section">
        <div className="container">
          {/* <a href="https://ftm.banksy.farm">
            <figure className="image is-fullwidth is-hidden-mobile mb-5">
              <img src="/images/banner.gif" alt="Banner" />
            </figure>
          </a> */}
          <MoneyRecipeSection />
          <CountdownSection />
          <FarmsStakingSection farmState={ farmState } />
          <div className="columns">
            <div className="column is-two-third is-flex">
              <TotalValueLockedSection farmState={ farmState } poolState={ poolState } vaultState={ vaultState } />
            </div>
            <div className="column is-one-third">
              <NewsSection />
            </div>
          </div>
          <EarnUpToSection farmState={ farmState } poolState={ poolState } vaultState={ vaultState } />
        </div>
      </main>
      <div className="parallax is-hidden-mobile" style={{ backgroundImage: 'url("/images/parallax/bg-0.png")', height: '100vh' }} />
    </>
  );
}

export default DashboardPage;
